import React from 'react';
import { connect } from 'react-redux';
import properties from '../../modules/ajio-util/properties';
import getChannelType from '../../utils/getChannelType';
import { getLuxeFlags } from '../../Flags/selectors';
import { getCurrentStore } from '../../refresh/selectors/metaData';

const imageBaseUrl = properties.getProperty('imageBaseUrl');

class Loader extends React.Component {
  render() {
    const { show = false, defaultIcon = true, className = '', newDesignLuxe } = this.props;
    const device = getChannelType();
    const url =
      device === 'MSITE' || newDesignLuxe
        ? `${imageBaseUrl}/static/img/refreshsitespinner_2.gif`
        : `${imageBaseUrl}/static/img/sitespinner.gif`;
    if (!show) {
      return null;
    }
    return (
      <div className={`loader ${className}`}>
        {defaultIcon ? <img src={url} alt="Ajio loader" /> : null}
        {this.props.children}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { loaders = {}, flags } = state;
  const { isDesktopThemeEnable } = getLuxeFlags(flags);
  const storeName = getCurrentStore(state);
  const newDesignLuxe = isDesktopThemeEnable === 'ON' && storeName === 'luxe';
  const { name, forceShow = false } = ownProps;
  let show = false;
  if (loaders[name] || forceShow) {
    show = true;
  }
  return {
    show,
    newDesignLuxe
  };
};

export default connect(mapStateToProps)(Loader);
